import {useSelector} from "react-redux";
import {appConfigSelector} from "../../../slices/appSlice";
import {useState} from "react";
import useToast from "../../../util/useToast";
import {useTranslation} from "react-i18next";
import {updateSettingsGeneral} from "../../../api/ApiSettings";
import useNetwork from "../../../util/useNetwork";

export const DATE_FORMATS = [
  "DD/MM/YYYY",
  "DD-MM-YYYY",
  "DD.MM.YYYY",
  "YYYY/MM/DD",
  "YYYY-MM-DD",
  "YYYY.MM.DD",
  "MM/DD/YYYY",
  "MM-DD-YYYY",
  "MM.DD.YYYY"
];

export const NUMBER_FORMATS = {
  "123.456,78": {decimalSeparator: ",", thousandSeparator: "."},
  "123,456.78": {decimalSeparator: ".", thousandSeparator: ","},
  "123 456,78": {decimalSeparator: ",", thousandSeparator: " "},
  "123 456.78": {decimalSeparator: ".", thousandSeparator: " "}
}

const useSettingsGeneral = () => {
  const {showToastSuccess} = useToast();
  const {handleNetworkError} = useNetwork();
  const {t} = useTranslation("settings_general");

  const {
    locale,
    decimalSeparator,
    thousandSeparator,
    dateFormat,
    currencyMain
  } = useSelector(appConfigSelector);

  const [editedSettings, setEditedSettings] = useState({
    errors: {},
    locale,
    numberFormat: Object.keys(NUMBER_FORMATS).find(k => NUMBER_FORMATS[k].decimalSeparator === decimalSeparator && NUMBER_FORMATS[k].thousandSeparator === thousandSeparator),
    dateFormat,
    currencyMain,
  });

  const submit = e => {
    e.preventDefault();

    const numberFormat = NUMBER_FORMATS[editedSettings.numberFormat];

    updateSettingsGeneral({...editedSettings, ...numberFormat})
      .then(() => showToastSuccess(t("toast_general_editor_saved")))
      .catch(handleNetworkError);
  };

  const updateSetting = field => event => {
    const values = {};

    switch (field) {
      case "locale":
      case "numberFormat":
      case "dateFormat":
      case "currencyMain":
        values[field] = event;
        break;
      default:
        values[field] = event.target.value;
        break;
    }

    setEditedSettings(prev => ({...prev, ...values}));
  };

  return {
    t,
    editedSettings,
    submit,
    updateSetting
  };
};

export default useSettingsGeneral;
